import { useRef, useEffect } from 'react';
import './ContentCarousel.css';

// Simplified approach to get asset path (pointing to public directory)
const getAssetPath = (name: string) => {
  return `/assets/Brands/${name}`;
};

// Brand logos file names
const brandLogoFiles = [
  'Black with logo on left - no backround.svg', // Reverted back to the SVG logo
  'Advocis.png', // Replaced images.png
  'industrial-alliance-logo-png_seeklogo-530643.png',
  'BMO.png', 
  'scotiabank-logo-2.png',
  'PPI.png' // Added PPI logo
];

export default function ContentCarousel() {
  const slideRef = useRef<HTMLDivElement>(null);

  // This effect ensures the animation is perfectly timed to the width of the content
  useEffect(() => {
    const adjustAnimation = () => {
      if (slideRef.current) {
        // Calculate the total width of one set of logos
        const totalWidth = slideRef.current.scrollWidth / 2;
        
        // Determine if we're on mobile
        const isMobile = window.innerWidth <= 768;
        
        // Use different speed calculations for mobile vs desktop
        // Desktop: slower speed (higher duration)
        // Mobile: faster speed (lower duration) to match perceived desktop speed
        const pixelsPerSecond = isMobile ? 100 : 50; // Mobile moves at 2x speed
        const calculatedDuration = totalWidth / pixelsPerSecond;
        
        // Apply the calculated animation duration
        slideRef.current.style.animationDuration = `${calculatedDuration}s`;
      }
    };

    adjustAnimation();
    window.addEventListener('resize', adjustAnimation);
    
    return () => {
      window.removeEventListener('resize', adjustAnimation);
    };
  }, []);

  return (
    <div className="carousel-container">
      <div className="carousel-slide" ref={slideRef}>
        {/* First set of logos */}
        {brandLogoFiles.map((logoFile, index) => {
          const isPpiLogo = logoFile === 'PPI.png';
          return (
            <img 
              key={index}
              src={getAssetPath(logoFile)} 
              alt={`Brand Logo ${index + 1}`} 
              className={`carousel-logo ${isPpiLogo ? 'ppi-logo' : ''}`}
            />
          );
        })}
        
        {/* Duplicate set for seamless loop */}
        {brandLogoFiles.map((logoFile, index) => {
          const isPpiLogo = logoFile === 'PPI.png';
          return (
            <img 
              key={`duplicate-${index}`}
              src={getAssetPath(logoFile)} 
              alt={`Brand Logo ${index + 1}`}
              className={`carousel-logo ${isPpiLogo ? 'ppi-logo' : ''}`} 
            />
          );
        })}
      </div>
    </div>
  );
}
